import React from 'react';
import PropTypes from 'prop-types';
import { createQueryParamModalHelpers } from 'shared/utils/queryParamModal';
import { Modal } from 'components/shared';
import BidActivity from './BidActivity';
import RunList from './RunList';
import UserList from './UserList';
import Settings from './Settings';
import Item from './Item';
import { Container } from './Styles';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { getStreamerHost } from '../../../../endpoints';
import Version from '../../../shared/Version';

const SideNavContainer = observer(
  ({
    auctionList,
    currentAuctionId,
    laneList,
    currentLaneId,
    runList,
    currentLotNumber,
    userList,
    handleAuctionChange,
    handleLaneChange,
    totalClientsInLane,
    totalClerksInLane,
    totalUnitsRemaining,
    handleOpenItemClick,
  }) => {
    const {
      AuctionStore: { layoutSettings },
    } = useStores();

    const screens = layoutSettings;

    const handleClick = (route, layout) => window.open(`/${route}`, layout, '');

    const settingsModalHelpers = createQueryParamModalHelpers('settings-view');
    const userListModalHelpers = createQueryParamModalHelpers('userlist-view');
    const runListModalHelpers = createQueryParamModalHelpers('runlist-view');
    const bidActivityModalHelpers = createQueryParamModalHelpers(
      'bidactivity-view',
    );

    return (
      <>
        <Container>
          <Version />
          <Item
            onClick={settingsModalHelpers.open}
            icon="fa-cog"
            testid="sidepanel-settings"
            text="Settings"
          />
          {(runList.length || null) && (
            <Item
              onClick={bidActivityModalHelpers.open}
              icon="fa-th-list"
              testid="sidepanel-bidactivity"
              text="Bid Activity"
            />
          )}
          {(runList.length || null) && (
            <Item
              key={totalClientsInLane}
              onClick={userListModalHelpers.open}
              icon="fa-user-circle-o"
              text="Online Users"
              testid="sidepanel-bidders"
              badge={totalClientsInLane}
            />
          )}
          {(runList.length || null) && (
            <Item
              key={`runlist_${runList.length}`}
              testid="sidepanel-runlist"
              onClick={runListModalHelpers.open}
              icon="fa-motorcycle"
              text="Run List"
              badge={totalUnitsRemaining || 0}
            />
          )}

          <div style={{ position: 'absolute', marginTop: 'calc(100vh - 300px)' }}>
            <Item
              data-testid="btn-streamer"
              key="sidepanel-streamer"
              icon="fa-window-restore"
              onClick={(e) => {
                e.preventDefault();
                window.open(getStreamerHost(), 'streamerWindow', '');
              }}
              text="Audio Streamer"
            />
            {screens
              ?.filter((item) => item.layoutType !== 'Bidder')
              ?.sort((a, b) =>
                a.layout < b.layout ? -1 : a.layout > b.layout ? 1 : 0,
              )
              .map(({ slug, layout, layoutID }) => (
                <Item
                  key={`launchpad-${layoutID}`}
                  testid="sidepanel-launchpad"
                  onClick={() => handleClick(slug, layout)}
                  icon="fa-window-restore"
                  text={layout
                    .replace('NPA Vehicle ', '')
                    .replace('Screen', '')}
                />
              ))}
          </div>
        </Container>

        {settingsModalHelpers.isOpen() && (
          <Modal
            isOpen
            testid="modal:settings-view"
            variant="aside"
            width={350}
            onClose={settingsModalHelpers.close}
            renderContent={() => (
              <Settings
                auctionList={auctionList}
                laneList={laneList}
                currentAuctionId={currentAuctionId}
                currentLaneId={currentLaneId}
                totalClerksInLane={totalClerksInLane}
                handleAuctionChange={handleAuctionChange}
                handleLaneChange={(e) => {
                  settingsModalHelpers.close();
                  handleLaneChange(e);
                }}
              />
            )}
          />
        )}

        {bidActivityModalHelpers.isOpen() && (
          <Modal
            isOpen
            testid="modal:bidactivity-view"
            variant="aside"
            width={350}
            onClose={bidActivityModalHelpers.close}
            renderContent={() => <BidActivity />}
          />
        )}

        {userListModalHelpers.isOpen() && (
          <Modal
            isOpen
            testid="modal:userlist-view"
            variant="aside"
            width={350}
            onClose={userListModalHelpers.close}
            renderContent={() => (
              <UserList
                key={`userlist_${
                  userList.filter((item) => item.viewOnly === false).length
                }`}
                onCloseWindow={userListModalHelpers.close}
              />
            )}
          />
        )}

        {runListModalHelpers.isOpen() && (
          <Modal
            isOpen
            testid="modal:runlist-view"
            variant="aside"
            width={350}
            onClose={runListModalHelpers.close}
            renderContent={() => (
              <RunList
                key={`runlist_${currentLotNumber}`}
                onRunListItemClick={(e) => {
                  runListModalHelpers.close();
                  handleOpenItemClick(e);
                }}
                currentLotNumber={currentLotNumber}
              />
            )}
          />
        )}
      </>
    );
  },
);

SideNavContainer.propTypes = {
  auctionList: PropTypes.object,
  currentAuctionId: PropTypes.any,
  laneList: PropTypes.object,
  userList: PropTypes.object,
  currentLaneId: PropTypes.any,
  runList: PropTypes.object,
  currentLotNumber: PropTypes.any,
  totalClientsInLane: PropTypes.number,
  totalClerksInLane: PropTypes.number,
  handleAuctionChange: PropTypes.func.isRequired,
  handleLaneChange: PropTypes.func.isRequired,
  handleOpenItemClick: PropTypes.func.isRequired,
};

SideNavContainer.defaultProps = {
  auctionList: [],
  currentAuctionId: null,
  laneList: [],
  userList: [],
  currentLaneId: null,
  runList: [],
  currentLotNumber: null,
  totalClientsInLane: null,
  totalClerksInLane: null,
};

export default SideNavContainer;
